import axios from 'axios';
import _ from 'lodash';
import Constants from '../constants';
import { ICustomQuestion, ICustomQuestionEditModel, IValidationModel } from '../models';

export function getCustomQuestionsUrl(surveyId: number, cultureCode: string, isDemographic: boolean) {
	let query = Constants.CUSTOMQUESTIONS_API.replace('{surveyId}', surveyId.toString()) + `?defaultCultureCode=${cultureCode}`;
	if (isDemographic != null) {
		query += `&isDemographic=${isDemographic.toString()}`;
	}
	return query;
}

export async function getCustomQuestions(surveyId: number, defaultCultureCode: string, isDemographic: boolean): Promise<ICustomQuestion[]> {
	try {
		const url = getCustomQuestionsUrl(surveyId, defaultCultureCode, isDemographic);
		const res = await axios.get(url, { headers: { Pragma: 'no-cache' } });
		if (res.status === 200) {
			return res.data;
		}
	} catch (Error) {
		/*For now always returning the generic error below to keep the same behavior as fetch for 500 errors.*/
	}
	throw Error('An error occurred trying to fetch custom questions.');
}

export async function addCustomQuestion(
	surveyId: number,
	customQuestion: ICustomQuestionEditModel,
): Promise<IValidationModel<ICustomQuestionEditModel>> {
	const url = getCustomQuestionEditModelUrl(surveyId);
	const result = await axios.post(url, customQuestion).catch((error) => {
		if (error.response.status === 422) {
			return error.response;
		}
		throw Error('An error occurred trying to save a custom question.');
	});
	return result.data;
}

export async function updateCustomQuestion(
	surveyId: number,
	customQuestion: ICustomQuestionEditModel,
): Promise<IValidationModel<ICustomQuestionEditModel>> {
	if (customQuestion.surveyQuestionId === undefined) {
		return addCustomQuestion(surveyId, customQuestion);
	}
	const url = getCustomQuestionEditModelUrl(surveyId, customQuestion.surveyQuestionId);
	const result = await axios.put(url, customQuestion).catch((error) => {
		if (error.response.status === 422) {
			return error.response;
		}
		throw Error('An error occurred trying to save a custom question.');
	});
	return result.data;
}

export function getCustomQuestionEditModelUrl(surveyId: number, surveyQuestionId?: number) {
	let url = Constants.CUSTOMQUESTIONS_EDITMODEL_API.replace('{surveyId}', surveyId.toString());
	if (surveyQuestionId === undefined || surveyQuestionId === 0) {
		url = url.replace('/{surveyQuestionId}', '');
	} else {
		url = url.replace('{surveyQuestionId}', surveyQuestionId.toString());
	}
	return url;
}

export async function getCustomQuestionEditModel(surveyId: number, surveyQuestionId: number): Promise<ICustomQuestionEditModel> {
	try {
		const url = getCustomQuestionEditModelUrl(surveyId, surveyQuestionId);
		const res = await axios.get(url, { headers: { Pragma: 'no-cache' } });
		if (res.status === 200) {
			return res.data;
		}
	} catch (Error) {
		/*For now always returning the generic error below to keep the same behavior as fetch for 500 errors.*/
	}
	throw Error('An error occurred trying to fetch a custom question.');
}
